import React from "react"

export const menu = []

export const MenuContext = React.createContext(menu)
